import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { up, down } from 'slide-element';
import { createFocusTrap } from 'focus-trap';
import clickOutside from 'click-outside';
import announcer from './aria-announcer';

const btns = document.querySelectorAll('.btn-tools');
const panel = document.querySelector('.tools-panel');
const toolsWrapper = panel?.querySelector('.tools-panel-wrapper');
const btnClose = panel?.querySelector('.btn-close');
const body = document.querySelector('body');
const toolsPanelList = document.querySelectorAll('.tools-panel-list');
const btnMobileMenu = document.querySelector('.btn-mobile');

let focusTrap = null;
let unbindClickOutside = null;
let activeBtn = null;

const closePanel = () => {
    activeBtn?.setAttribute('aria-expanded', 'false');
    panel.classList.remove('expanded');
    body.classList.remove('locked');
    announcer.announce('La section des outils Viamonde est fermé');

    if (btnMobileMenu && !btnMobileMenu.classList.contains('open')) {
        enableBodyScroll(toolsWrapper);
    }

    if (focusTrap) {
        focusTrap.deactivate();
        focusTrap = null;
    }

    if (unbindClickOutside) {
        unbindClickOutside();
        unbindClickOutside = null;
    }

    activeBtn = null;
    setTimeout(() => {
        panel.setAttribute('aria-hidden', 'true');
    }, 100);
};

const openPanel = (btn) => {
    panel.classList.add('expanded');
    panel.removeAttribute('aria-hidden');
    disableBodyScroll(toolsWrapper, {
        allowTouchMove: (el) => el.closest('.tools-panel-wrapper') !== null,
    });
    btn.setAttribute('aria-expanded', 'true');
    body.classList.add('locked');
    activeBtn = btn;

    setTimeout(() => {
        focusTrap = createFocusTrap(panel, {
            clickOutsideDeactivates: true,
            preventScroll: true,
        });
        focusTrap.activate();
        unbindClickOutside = clickOutside(panel, closePanel);
        announcer.announce('La section des outils Viamonde est ouverte');
    }, 100);
};

btns.forEach((btn) => {
    btn.addEventListener('click', () => {
        const isExpanded = panel.classList.contains('expanded');

        if (isExpanded) {
            closePanel();
        } else {
            openPanel(btn);
        }
    });
});

btnClose?.addEventListener('click', closePanel);

toolsPanelList.forEach((ul) => {
    const items = Array.from(ul.querySelectorAll('li'));
    const btnList = ul.nextElementSibling;

    if (!(btnList && btnList.classList.contains('btn-plus'))) return;

    if (items.length <= 3) {
        btnList.style.display = 'none';
        return;
    }

    const hiddenItems = items.slice(3);
    const label = btnList.querySelector('.btn-label');
    const iconExpand = btnList.querySelector('.icon-expand');
    const iconCollapse = btnList.querySelector('.icon-collapse');

    hiddenItems.forEach((li) => {
        const liEl = li;
        liEl.setAttribute('aria-hidden', 'true');
        liEl.style.overflow = 'hidden';
        up(liEl);
    });

    let expanded = false;

    btnList.addEventListener('click', () => {
        if (!expanded) {
            hiddenItems.forEach((li) => {
                li.setAttribute('aria-hidden', 'false');
                down(li);
            });
            btnList.setAttribute('aria-expanded', 'true');
            label.textContent = btnList.dataset.expandedText;
            iconExpand.style.display = 'none';
            iconCollapse.style.display = '';
        } else {
            hiddenItems.forEach((li) => {
                li.setAttribute('aria-hidden', 'true');
                up(li);
            });
            btnList.setAttribute('aria-expanded', 'false');
            label.textContent = btnList.dataset.collapsedText;
            iconExpand.style.display = '';
            iconCollapse.style.display = 'none';
        }

        expanded = !expanded;
    });
});
